import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { t } from "../../translations";

import { Aa } from "../functions/Aa";
import "../styles/section-chef.css";

import ImgUpload from "../../assets/img-upload.png";
import PreviewBanner from "../../assets/preview-banner.png";

import Profil1 from "../../assets/profil-1.png";
import Profil2 from "../../assets/profil-2.png";
import Profil3 from "../../assets/profil-3.png";
import Profil4 from "../../assets/profil-4.png";

import { useState } from "react";
import { GET, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { POST_USER_DATA } from "../../store/action";
import { createLogger } from "../../utils/logger";
import { countries } from "../constants/countries";
import { uploadFile } from "../functions/upload-file";
import { openNotificationWithIcon } from "./notification-bar";

const logger = createLogger("SelectProfil");

const SelectProfil = (props) => {
  const { profil, setProfil, user, lang } = props;
  const history = useHistory();

  const [geographical, setGeographical] = useState([]);

  const [pic1, setPic1] = useState(null);

  const [pic2, setPic2] = useState(null);

  const [pic3, setPic3] = useState(null);

  const [preview, setPreview] = useState(null);

  const pic1InputRef = useRef(null);
  const pic2InputRef = useRef(null);
  const pic3InputRef = useRef(null);

  const previewInputRef = useRef(null);

  const [load, setLoad] = useState(false);

  const dispatch = useDispatch();

  const post_user_data = (data) => {
    dispatch(post_user(data));
  };

  useEffect(() => {
    initialData();
  }, []);

  // Initialize image previews when user data is available
  useEffect(() => {
    if (user) {
      logger.log("User data for images:", {
        pic1: user.pic1,
        pic2: user.pic2,
        pic3: user.pic3,
        preview: user.preview
      });

      // Set initial preview states from user data
      if (user.pic1 && typeof user.pic1 === "string") {
        setPic1(user.pic1);
      }
      if (user.pic2 && typeof user.pic2 === "string") {
        setPic2(user.pic2);
      }
      if (user.pic3 && typeof user.pic3 === "string") {
        setPic3(user.pic3);
      }
      if (user.preview && typeof user.preview === "string") {
        setPreview(user.preview);
      }
    }
  }, [user]);

  // Debug profil state changes
  useEffect(() => {
    logger.log("Profil state changed:", {
      pic1: profil?.pic1,
      pic2: profil?.pic2,
      pic3: profil?.pic3,
      preview: profil?.preview
    });
  }, [profil]);

  const initialData = async () => {
    setLoad(true);
    const request_details_geographical = {
      type: GET,
      url: service_api,
      route: `geographical/get-actif`,
      data: null,
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details_geographical);
      const decryptedData = decryptSingleData(response.data.geographical);
      setGeographical(decryptedData);
      setLoad(false);
    } catch (err) {
      setLoad(false);
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    }
  };

  const handleButtonClick = (index) => {
    if (index === 0) {
      return pic1InputRef.current.click();
    }

    if (index === 1) {
      return pic2InputRef.current.click();
    }
    if (index === 2) {
      return pic3InputRef.current.click();
    }
    if (index === 3) {
      return previewInputRef.current.click();
    }
  };

  const handleFileSelect = (event, index) => {
    const selectedFile = event.target.files[0];

    readFileAsUrl(selectedFile, index);
    if (index === 0) {
      return setProfil({
        ...profil,
        pic1: selectedFile
      });
    }
    if (index === 1) {
      return setProfil({
        ...profil,
        pic2: selectedFile
      });
    }
    if (index === 2) {
      return setProfil({
        ...profil,
        pic3: selectedFile
      });
    }
    if (index === 3) {
      return setProfil({
        ...profil,
        preview: selectedFile
      });
    }
  };

  const saveUpdate = async () => {
    setLoad(true);

    let preview_url, pic1_url, pic2_url, pic3_url;

    if (profil?.preview !== user?.preview) {
      preview_url = await uploadFile(profil?.preview);
      if (!preview_url.data.success) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          t("select_profil.image_upload_error", lang)
        );
      }
    }
    if (profil?.pic1 !== user?.pic1) {
      pic1_url = await uploadFile(profil?.pic1);
      if (!pic1_url.data.success) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          t("select_profil.image_upload_error", lang)
        );
      }
    }

    if (profil?.pic2 !== user?.pic2) {
      pic2_url = await uploadFile(profil?.pic2);
      if (!pic2_url.data.success) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          t("select_profil.image_upload_error", lang)
        );
      }
    }

    if (profil?.pic3 !== user?.pic3) {
      pic3_url = await uploadFile(profil?.pic3);
      if (!pic3_url.data.success) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          t("select_profil.image_upload_error", lang)
        );
      }
    }

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `user/update-user/${user?._id}`,
      data: {
        max_dish: profil?.max_dish,
        firstname: profil?.firstname,
        lastname: profil?.lastname,
        email: profil?.email,
        number: profil?.number,
        bio: profil?.bio,
        notification: profil?.notification,
        notification_cancel: profil?.notification_cancel,
        order_timing: profil?.order_timing,
        country: profil?.country,
        geographical_tag: profil?.geographical_tag,
        availability: profil?.availability,
        preview:
          profil?.preview !== user?.preview
            ? preview_url.data.url
            : user?.preview,
        pic1: profil?.pic1 !== user?.pic1 ? pic1_url.data.url : user?.pic1,
        pic2: profil?.pic2 !== user?.pic2 ? pic2_url.data.url : user?.pic2,
        pic3: profil?.pic3 !== user?.pic3 ? pic3_url.data.url : user?.pic3
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const decryptedData = decryptSingleData(response.data.user);
      post_user_data({
        ...decryptedData
      });
      setLoad(false);
      return history.push("/chef/iam-a-chef/home");
    } catch (err) {
      setLoad(false);
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    }
  };

  const readFileAsUrl = (file, index) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (index === 0) {
        setPic1(reader.result);
      }
      if (index === 1) {
        setPic2(reader.result);
      }
      if (index === 2) {
        setPic3(reader.result);
      }
      if (index === 3) {
        setPreview(reader.result);
      }
    };
    return reader.readAsDataURL(file);
  };

  return (
    <div
      className="section-chef-menu-right-profil"
      style={{ padding: "20px 40px" }}
    >
      <div className="section-chef-menu-right-profil-inside">
        <div
          className="section-chef-menu-right-profil-inside-box"
          style={{
            marginTop: 0,
            maxWidth: "1200px",
            margin: "0 auto"
          }}
        >
          <div className="section-chef-menu-right-profil-inside-left">
            <p
              style={{
                fontSize: 28,
                fontWeight: 600,
                marginBottom: 10,
                color: "#333"
              }}
            >
              {t("select_profil.profile", lang)}
            </p>
            <p
              style={{
                fontSize: 16,
                color: "#666",
                marginBottom: 30
              }}
            >
              {t("select_profil.modify_your_information", lang)}
            </p>
            <div
              className="profile-picture-section"
              style={{
                width: "100%",
                border: "1px solid #eeeeee",
                padding: 20,
                borderRadius: 10,
                marginBottom: 20
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: "600"
                }}
              >
                {t("select_profil.profile_picture", lang)}
              </p>
              <p
                style={{
                  fontSize: 14,
                  fontWeight: 300
                }}
              >
                {t("select_profil.show_yourself_description", lang)}
              </p>
              <div
                className="profile-picture-upload-container"
                style={{
                  width: "100%",
                  display: "flex",
                  gap: 10
                }}
              >
                {[
                  { img: profil?.pic1 || user?.pic1, local: pic1 },
                  { img: profil?.pic2 || user?.pic2, local: pic2 }
                ].map((item, index) => (
                  <img
                    key={index}
                    className="img-upload-pic"
                    src={
                      !item?.img || item?.img === null || item?.img === ""
                        ? ImgUpload
                        : typeof item?.img === "string"
                          ? item?.img
                          : item?.local || ImgUpload
                    }
                    alt="img-upload"
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: 40,
                      objectFit: "cover"
                    }}
                    onClick={() => {
                      handleButtonClick(index);
                    }}
                  />
                ))}
                {[pic1InputRef, pic2InputRef, pic3InputRef].map(
                  (item, index) => (
                    <input
                      key={index}
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      ref={item}
                      style={{
                        display: "none"
                      }}
                      onChange={(e) => handleFileSelect(e, index)}
                    />
                  )
                )}
              </div>
              <p
                style={{
                  fontSize: 14,
                  fontWeight: 600
                }}
              >
                {t("select_profil.instructions_profile_photo", lang)}
              </p>
              <p
                style={{
                  fontSize: 13,
                  fontWeight: 400
                }}
              >
                {t("select_profil.photo_instructions_text", lang)}
              </p>
              <ol
                style={{
                  fontSize: 13,
                  paddingLeft: 20,
                  textAlign: "left"
                }}
              >
                <li
                  style={{
                    fontSize: 13
                  }}
                >
                  {t("select_profil.photo_instruction_1", lang)}
                </li>
                <li
                  style={{
                    fontSize: 13
                  }}
                >
                  {t("select_profil.photo_instruction_2", lang)}
                </li>
                <li
                  style={{
                    fontSize: 13
                  }}
                >
                  {t("select_profil.photo_instruction_3", lang)}
                </li>
                <li
                  style={{
                    fontSize: 13
                  }}
                >
                  {t("select_profil.photo_instruction_4", lang)}
                </li>
              </ol>
              <div
                className="profile-picture-examples-container"
                style={{
                  width: "100%",
                  display: "flex",
                  gap: 10
                }}
              >
                {[Profil1, Profil2, Profil3, Profil4].map((item, index) => (
                  <img
                    key={index}
                    src={item}
                    alt="img-upload"
                    style={{
                      width: 60
                    }}
                  />
                ))}
              </div>
            </div>

            <div
              style={{
                width: "100%",
                border: "1px solid #eeeeee",
                padding: 20,
                borderRadius: 10,
                marginTop: 20,
                marginBottom: 20
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: "600"
                }}
              >
                {t("select_profil.country_origin_region", lang)}
              </p>
              {[
                {
                  title: t("select_profil.select_country_origin", lang),
                  name: "country",
                  type: "select",
                  data: countries,
                  value: profil?.country,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      country: e.target.value
                    })
                },
                {
                  title: t("select_profil.select_kitchen_region", lang),
                  name: "geographical_tag",
                  type: "select",
                  data: geographical,
                  value: profil?.geographical_tag,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      geographical_tag: e.target.value
                    })
                }
              ]?.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {}}
                  style={{
                    width: "100%"
                  }}
                >
                  <select
                    className="select-address-box"
                    style={{
                      backgroundColor: "#eeeeee",
                      paddingLeft: 10,
                      borderRadius: 5,
                      height: 40
                    }}
                    placeholder={item?.placeholder}
                    name={item?.name}
                    value={item?.value || ""}
                    onChange={(e) => {
                      item?.onChange(e);
                    }}
                  >
                    <option value="">{item?.title}</option>
                    {item.name === "country" &&
                      item?.data.map((item, index) => (
                        <option
                          key={index}
                          value={lang === "en" ? item?.name : item?.fr_name}
                        >
                          {lang === "en" ? item?.name : item?.fr_name}
                        </option>
                      ))}
                    {item.name === "geographical_tag" &&
                      item?.data.map((item, index) => (
                        <option key={index} value={item?.country_name}>
                          {lang === "en" ? Aa(item?.eng_name) : Aa(item?.name)}
                        </option>
                      ))}
                  </select>
                </div>
              ))}
            </div>
            <div
              style={{
                width: "100%",
                border: "1px solid #eeeeee",
                padding: 20,
                borderRadius: 10,
                marginTop: 20,
                marginBottom: 20
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: "600"
                }}
              >
                {t("select_profil.personal_information", lang)}
              </p>
              {[
                {
                  placeholder: t("select_profil.enter_firstname", lang),
                  name: "firstname",
                  type: "text",
                  value: profil?.firstname,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      firstname: e.target.value
                    })
                },
                {
                  placeholder: t("select_profil.enter_lastname", lang),
                  name: "lastname",
                  type: "text",
                  value: profil?.lastname,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      lastname: e.target.value
                    })
                },
                {
                  placeholder: t("select_profil.enter_email", lang),
                  name: "email",
                  type: "text",
                  value: profil?.email,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      email: e.target.value
                    })
                },
                {
                  placeholder: t("select_profil.enter_mobile", lang),
                  name: "number",
                  type: "text",
                  value: profil?.number,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      number: e.target.value
                    })
                }
              ]?.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {}}
                  style={{
                    width: "100%"
                  }}
                >
                  <input
                    className="select-address-box"
                    style={{
                      backgroundColor: "#eeeeee",
                      paddingLeft: 10,
                      borderRadius: 40,
                      height: 40
                    }}
                    placeholder={item?.placeholder}
                    type={item?.type}
                    name={item?.name}
                    value={item?.value}
                    onChange={(e) => {
                      item?.onChange(e);
                    }}
                  />
                </div>
              ))}
            </div>
            <div
              style={{
                width: "100%",
                border: "1px solid #eeeeee",
                padding: 20,
                borderRadius: 10,
                marginTop: 20,
                marginBottom: 20
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 600
                }}
              >
                {t("select_profil.bio", lang)}
              </p>
              <p
                style={{
                  fontSize: 14,
                  fontWeight: 400
                }}
              >
                {t("select_profil.bio_description", lang)}
              </p>
              {[
                {
                  placeholder: t("select_profil.bio_example", lang),
                  name: "bio",
                  type: "text",
                  value: profil?.bio,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      bio: e.target.value
                    })
                }
              ]?.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {}}
                  style={{
                    width: "100%"
                  }}
                >
                  <textarea
                    className="select-address-box"
                    rows={4}
                    style={{
                      backgroundColor: "#eeeeee",
                      paddingLeft: 10,
                      borderRadius: 5,
                      height: "auto"
                    }}
                    placeholder={item?.placeholder}
                    type={item?.type}
                    name={item?.name}
                    value={item?.value}
                    onChange={(e) => {
                      item?.onChange(e);
                    }}
                    maxLength={200}
                  />
                  <p
                    style={{
                      fontSize: 12
                    }}
                  >
                    {t("select_profil.max_words_allowed", lang)}
                  </p>
                </div>
              ))}
            </div>
            <div
              style={{
                width: "100%",
                border: "1px solid #eeeeee",
                padding: 20,
                borderRadius: 10,
                marginTop: 20,
                marginBottom: 20
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 600
                }}
              >
                {t("select_profil.overview_profile_banner", lang)}
              </p>
              <p
                style={{
                  fontSize: 14,
                  fontWeight: 400
                }}
              >
                {t("select_profil.add_image_preview_banner", lang)}
              </p>
              <div
                style={{
                  width: "100%",
                  gap: 10,
                  display: "flex",
                  flexDirection: "column"
                }}
              >
                <p
                  style={{
                    fontSize: 14,
                    fontWeight: 400
                  }}
                >
                  {t("select_profil.profile_preview", lang)}
                </p>
                <img
                  className="img-upload-pic"
                  src={
                    !(profil?.pic3 || user?.pic3) ||
                    (profil?.pic3 || user?.pic3) === null ||
                    (profil?.pic3 || user?.pic3) === ""
                      ? PreviewBanner
                      : typeof (profil?.pic3 || user?.pic3) === "string"
                        ? profil?.pic3 || user?.pic3
                        : pic3 || PreviewBanner
                  }
                  alt="img-upload"
                  style={{
                    width: 150,
                    height: 150,
                    borderRadius: 10,
                    objectFit: "cover",
                    border: "1px solid #eeeeee"
                  }}
                  onClick={() => {
                    handleButtonClick(2);
                  }}
                />
                <p
                  style={{
                    fontSize: 14,
                    fontWeight: 400
                  }}
                >
                  {t("select_profil.profile_banner", lang)}
                </p>
                <img
                  className="img-upload-pic"
                  src={
                    !(profil?.preview || user?.preview) ||
                    (profil?.preview || user?.preview) === null ||
                    (profil?.preview || user?.preview) === ""
                      ? PreviewBanner
                      : typeof (profil?.preview || user?.preview) === "string"
                        ? profil?.preview || user?.preview
                        : preview || PreviewBanner
                  }
                  alt="img-upload"
                  style={{
                    width: "100%",
                    height: 120,
                    borderRadius: 10,
                    objectFit:
                      !profil?.preview && !user?.preview ? "contain" : "cover",
                    border: "1px solid #eeeeee",
                    marginTop: 10
                  }}
                  onClick={() => {
                    handleButtonClick(3);
                  }}
                />

                <input
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  ref={pic3InputRef}
                  style={{
                    display: "none"
                  }}
                  onChange={(e) => handleFileSelect(e, 2)}
                />
                <input
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  ref={previewInputRef}
                  style={{
                    display: "none"
                  }}
                  onChange={(e) => handleFileSelect(e, 3)}
                />
              </div>
            </div>
          </div>
          <div className="section-chef-menu-right-profil-inside-right">
            <p
              style={{
                fontSize: 28,
                fontWeight: 600,
                marginBottom: 10,
                color: "#333"
              }}
            >
              {t("select_profil.settings", lang)}
            </p>
            <p
              style={{
                fontSize: 16,
                color: "#666",
                marginBottom: 30
              }}
            >
              {t("select_profil.modify_your_settings", lang)}
            </p>
            <div
              style={{
                width: "100%",
                border: "1px solid #eeeeee",
                padding: 20,
                borderRadius: 10,
                marginTop: 20,
                marginBottom: 20
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 600
                }}
              >
                {t("select_profil.max_dishes_number", lang)}
              </p>
              <p
                style={{
                  fontSize: 14,
                  fontWeight: 400
                }}
              >
                {t("select_profil.max_dishes_description", lang)}
              </p>
              {[
                {
                  placeholder: t("select_profil.max_number_28", lang),
                  name: "max_dish",
                  type: "number",
                  value: profil?.max_dish,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      max_dish: e.target.value
                    })
                }
              ]?.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {}}
                  style={{
                    width: "100%"
                  }}
                >
                  <input
                    className="select-address-box"
                    style={{
                      backgroundColor: "#eeeeee",
                      paddingLeft: 10,
                      borderRadius: 20,
                      height: 40
                    }}
                    placeholder={item?.placeholder}
                    type={item?.type}
                    name={item?.name}
                    value={item?.value}
                    onChange={(e) => {
                      item?.onChange(e);
                    }}
                    maxLength={200}
                  />
                </div>
              ))}
            </div>
            <div
              style={{
                width: "100%",
                border: "1px solid #eeeeee",
                padding: 20,
                borderRadius: 10,
                marginTop: 20,
                marginBottom: 20
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 600
                }}
              >
                {t("select_profil.notification_on_order", lang)}
              </p>
              <p
                style={{
                  fontSize: 14,
                  fontWeight: 400
                }}
              >
                {t("select_profil.notification_description", lang)}
              </p>
              {[
                {
                  text: t("select_profil.no_notification", lang),
                  name: "notification",
                  onChange: () =>
                    setProfil({
                      ...profil,
                      notification: false
                    })
                },
                {
                  text: t("select_profil.yes_notification", lang),
                  name: "notification",
                  onChange: () =>
                    setProfil({
                      ...profil,
                      notification: true
                    })
                }
              ]?.map((item, index) => (
                <div
                  key={index}
                  onClick={(e) => {
                    item.onChange(e);
                  }}
                  className="notification-btn-enable"
                  style={{
                    width: "100%",
                    backgroundColor: "#eeeeee",
                    height: 50,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    fontSize: 15,
                    fontWeight: 600,
                    paddingLeft: 10,
                    marginTop: 10
                  }}
                >
                  <div
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 15,
                      backgroundColor: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    {index === 0 && (
                      <div
                        style={{
                          width: 15,
                          height: 15,
                          borderRadius: 7.5,
                          backgroundColor:
                            profil?.notification === false ? "#000" : "#fff"
                        }}
                      ></div>
                    )}
                    {index === 1 && (
                      <div
                        style={{
                          width: 15,
                          height: 15,
                          borderRadius: 7.5,
                          backgroundColor:
                            profil?.notification === true ? "#000" : "#fff"
                        }}
                      ></div>
                    )}
                  </div>
                  {item?.text}
                </div>
              ))}
            </div>
            <div
              style={{
                width: "100%",
                border: "1px solid #eeeeee",
                padding: 20,
                borderRadius: 10,
                marginTop: 20,
                marginBottom: 20
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 600
                }}
              >
                {t("select_profil.notification_cancellation", lang)}
              </p>
              <p
                style={{
                  fontSize: 14,
                  fontWeight: 400
                }}
              >
                {t("select_profil.notification_cancellation_description", lang)}
              </p>
              {[
                {
                  text: t("select_profil.no_notification", lang),
                  name: "notification_cancel",
                  onChange: () =>
                    setProfil({
                      ...profil,
                      notification_cancel: false
                    })
                },
                {
                  text: t("select_profil.yes_notification", lang),
                  name: "notification_cancel",
                  onChange: () =>
                    setProfil({
                      ...profil,
                      notification_cancel: true
                    })
                }
              ]?.map((item, index) => (
                <div
                  key={index}
                  onClick={(e) => {
                    item.onChange(e);
                  }}
                  className="notification-btn-enable"
                  style={{
                    width: "100%",
                    backgroundColor: "#eeeeee",
                    height: 50,
                    borderRadius: 5,
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    fontSize: 15,
                    fontWeight: 600,
                    paddingLeft: 10,
                    marginTop: 10
                  }}
                >
                  <div
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 15,
                      backgroundColor: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    {index === 0 && (
                      <div
                        style={{
                          width: 15,
                          height: 15,
                          borderRadius: 7.5,
                          backgroundColor:
                            profil?.notification_cancel === false
                              ? "#000"
                              : "#fff"
                        }}
                      ></div>
                    )}
                    {index === 1 && (
                      <div
                        style={{
                          width: 15,
                          height: 15,
                          borderRadius: 7.5,
                          backgroundColor:
                            profil?.notification_cancel === true
                              ? "#000"
                              : "#fff"
                        }}
                      ></div>
                    )}
                  </div>
                  {item?.text}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className="btn-get-started"
          style={{
            backgroundColor: "#ff114d",
            width: "100%"
          }}
          onClick={() => {
            if (load) {
              return;
            }
         
            return saveUpdate();
          }}
        >
          {!load && t("select_profil.save", lang)}
          {load && <CircularProgress size={25} />}
        </div>
        <div
          style={{
            height: 50
          }}
        ></div>
      </div>
    </div>
  );
};

export default SelectProfil;

const post_user = (data) => ({
  type: POST_USER_DATA,
  data: data
});
